import toastr from "toastr";
import moment from "moment";
import useMetaMask from "hooks/metsmask";
import { Oval } from 'react-loader-spinner'
import Web3Intraction from "utils/web3Intraction";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addPrintRequest, addPrintTranasction, getPrinterFromProduct } from "store/actions";
import { FetchCityListdata, FetchCountryListdata, FetchStateListdata } from "helpers/fetch_country_state_helper";
import { useNavigate } from "react-router-dom";
import { coversion } from "helpers/constants";
export default function PrintComp(props) {
    const { nftDet } = props;
    const hooks = useMetaMask();
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [states, setStates] = useState([]);
    const [citites, setCities] = useState([]);
    const [sellItem, setSellItem] = useState('')
    const [countries, setCountries] = useState([]);
    const [bidProgress, setBidProgress] = useState(false)
    const { user, settings } = useSelector((state) => state?.Login);
    const user_id = useSelector((s) => s.Login?.user?._id)
    const [ownerPriceMatic, setOwnerPriceMatic] = useState(0)
    const wallAddress = localStorage.getItem("walletAddress");
    const { Printers } = useSelector((state) => state?.Print);
    const [selectedPrinterId, setSelectedPrinterId] = useState('')
    const [printerChargeMatic, setPrinterChargeMatic] = useState(0)
    const [paperSizes, setPaperSizes] = useState(["A1", "A2", "A3", "A4"])
    const adminPercent = process.env.REACT_APP_ADMIN_PRINT_PERCENT
    const artistPercent = process.env.REACT_APP_ARTIST_PRINT_PERCENT
    const printerPercent = process.env.REACT_APP_PINTER_PRINT_PERCENT
    const adminPercentage = Number(process.env.REACT_APP_ADMIN_PRINT_PERCENT)
    const artistPercentage = Number(process.env.REACT_APP_ARTIST_PRINT_PERCENT)
    const [printInfo, setPrintInfo] = useState({
        nft_price: 0,
        printStyle: "Physical",
        size: "24 x 24",
        canvas_type: "A1",  // canvas type and paper type both data storing in the canvas type
        country: { name: "", code: "" },
        address: "",
        landmark: "",
        pincode: "",
        city: "",
        state: { name: "", code: "" },
        partner_id: "",
        print_charge: 0,
        tax: 0,
        user_id: user_id,
        nft_id: '',
        discount: 0,
        tax_percentage: 0,
        total_amount: 0,
        admin_commission: 0,
        seller_earning: 0,
        partner_earning: 0,
        total_cost: 0,
        print_option: "Paper",
        is_spray: false,
        admin_earning: 0,
        printer_earning: 0,
        printer_alone_charge: 0,
        spray_cost_per_inch: 0,
        serving_areas: [{ name: "", price: "", state: [] }],
        premium_charge: 0,
        total_cost_matic: 0

    })
    const [addPrintloding, setAddPrintLoading] = useState(false)
    const CloseDialog = () => {
        props.fucn()
    }
    useEffect(() => {
        if (nftDet) {
            setSellItem(nftDet)
        }
    }, [nftDet])
    useEffect(() => {
        if (printInfo?.printStyle || printInfo?.size || printInfo?.canvas_type) {
            let data = {}
            data.print_style = printInfo.printStyle
            data.size = printInfo.size
            data.canvas_type = printInfo.canvas_type
            // data.zipCode = printInfo?.pincode
            dispatch(getPrinterFromProduct(data))
        }
    }, [dispatch, printInfo])
    useEffect(() => {
        setPrintInfo((p) => ({ ...p, nft_id: nftDet?.nft_id?._id }))
    }, [nftDet])
    const sizeOptions = [
        { label: '24 x 24' },
        { label: '12 x 12' },
        { label: '10 x 10' },
        { label: '20 x 24' },
        { label: '8 x 10' },
    ];
    const formatDate = (date) =>
        date ? moment(date).utcOffset(330).format("DD MMM YYYY hh:mm A") : "---";
    const formatDateAddDays = (date) =>
        date
            ? moment(date).add(7, 'days').utcOffset(330).format("DD MMM YYYY hh:mm A")
            : "---";
    const addPrintCallback = (res) => {
        if (res.status === "success") {
            let printTransData = {};
            printTransData.print_request_id = res.data._id
            printTransData.admin_earning = calPercentAmt(adminPercent, printInfo?.print_charge)
            printTransData.seller_earning = calPercentAmt(artistPercent, printInfo?.print_charge)
            printTransData.printer_earning = calPercentAmt(printerPercent, printInfo?.print_charge)
            printTransData.total_amount = Number(printInfo?.print_charge) + Number(sellItem?.premium_print_cost || 0)
            printTransData.premium_amount = sellItem?.premium_print_cost
            printTransData.payment_status = "Completed"
            printTransData.status = "Completed"
            // new 
            printTransData.nft_id=printInfo.nft_id
            printTransData.from= sellItem?.creator_wallet
            printTransData.to= wallAddress 
            printTransData.user_id= user?._id
            const printTransCallback = (res) => {
                toastr.success("Print Request Added Successfully.")
                navigate("/profile/printrequest");
                setBidProgress(false)
            }

            dispatch(addPrintTranasction(printTransData, printTransCallback))

        } else {
            setBidProgress(false)
            toastr.error("Error in Print Request")
        }
    }

    useEffect(()=>{console.log("fsadfasdfasdf", printInfo, sellItem?.creator_wallet,wallAddress,user?._id)},[printInfo, sellItem?.creator_wallet,wallAddress, user?._id])
    const handleOnChangePrintInfo = (e, name, value) => {
        e.preventDefault()
        setSelectedPrinterId('')
        setSelectedPrinterId('')

        setPrintInfo((p) => {
            if (name === "country") {
                const countryInfo = countries.find((c) => c.code === value) || { name: "", code: "" };
                return { ...p, country: countryInfo, state: { name: "", code: "" }, city: "", partner_id: '', total_cost: 0 }; // Reset state and city when country changes
            }
            else if (name === "state") {
                const stateInfo = states.find((s) => s.code === value) || { name: "", code: "" };
                return { ...p, state: stateInfo, city: "", partner_id: '', total_cost: 0 }; // Reset city when state changes
            }
            else {
                return { ...p, [name]: value, partner_id: '', print_charge: 0, tax: 0, total_cost: 0 }
            }
        }
        )
        // setPrintInfo((p) => ({ ...p, [name]: value, partner_id: '', print_charge: 0, tax: 0 }))
    }
    const handlePrice = (x) => {
        if (printInfo?.print_option === "Canvas" && printInfo?.is_spray === false) {
            if (x && x.canvases.length > 0) {
                for (let i = 0; i < x.canvases.length; i++) {
                    let y = x.canvases[i];

                    // Check if the canvas type and size match the printInfo
                    if (y.name === printInfo.canvas_type && y.sizes.includes(printInfo.size)) {

                        // Split the size string and ensure it's valid
                        let size = printInfo?.size?.split(" ");

                        if (size.length < 3) {
                            console.error("Invalid size format.");
                            return null;
                        }

                        // Extract state price
                        let statePrice = x.serving_areas.flatMap(area =>
                            area.state
                                ?.filter(state => state.name === printInfo?.state?.name)
                                ?.map(state => state.price)
                        );

                        // Ensure statePrice has a valid value before proceeding
                        if (statePrice.length === 0) {
                            console.error("No state price found.");
                            return null;
                        }

                        // Calculate the price: canvas price + state price
                        let price = Number(Number(size[0]) * Number(size[2] * y.price)) + Number(statePrice[0]);

                        // Return the computed printer charge and price including admin and artist percentages
                        return {
                            printer_charge: Number(price),
                            price: Number(Number(price) + (Number(price) * (adminPercentage / 100)) + (Number(price) * (artistPercentage / 100))).toFixed(6)
                        };
                    }
                }
                return null;
            }
        } else {
            // Loop through papers if the print option is not "Canvas" or is_spray is false
            for (let i = 0; i < x.papers?.length; i++) {
                let y = x.papers[i];


                if (y.name === printInfo?.canvas_type) {

                    // Extract state price
                    let statePrice = x.serving_areas.flatMap(area =>
                        area.state
                            ?.filter(state => state.name === printInfo?.state?.name)
                            ?.map(state => state.price)
                    );

                    // Ensure statePrice has a valid value before proceeding
                    if (statePrice.length === 0) {
                        console.error("No state price found.");
                        return null;
                    }

                    // Calculate the price: paper price + state price
                    let price = Number(y?.price) + Number(statePrice[0]);

                    // Return the computed printer charge and price including admin and artist percentages
                    return {
                        printer_charge: Number(price),
                        price: Number(Number(price) + (Number(price) * (adminPercentage / 100)) + (Number(price) * (artistPercentage / 100))).toFixed(6)
                    };
                }
            }
            return null;
        }

    };
    const handlePrinterSelect = (e, item) => {
        e.preventDefault()
        setSelectedPrinterId(item?._id)
        if (printInfo?.is_spray === false) {
            setPrintInfo((p) => ({ ...p, print_charge: handlePrice(item).price, total_cost: handlePrice(item)?.price, partner_id: item._id, printer_alone_charge: handlePrice(item).printer_charge }))
        } else {
            setPrintInfo((p) => ({ ...p, print_charge: handlePriceWithSpray(item).price, total_cost: handlePriceWithSpray(item)?.price, partner_id: item._id, printer_alone_charge: handlePriceWithSpray(item).printer_charge }))
        }
    }
    const printOption = (e, event, size) => {
        e.preventDefault()
        setOwnerPriceMatic(0)
        setPrinterChargeMatic(0)

        if (event === "Paper") {
            setPrintInfo((p) => ({ ...p, print_option: event, canvas_type: paperSizes[0], is_spray: false, partner_id: '', total_cost: 0, total_cost_matic: 0 }))
        } else {
            setPrintInfo((p) => ({ ...p, print_option: event, canvas_type: "Canvas Lyve Matte", size: "24 x 24", is_spray: false, partner_id: '', total_cost: 0, total_cost_matic: 0 }))
        }
    }


    useEffect(() => {
        let data = {}
        data.type = printInfo?.print_option
        data.size = printInfo.size
        data.canvas_type = printInfo.canvas_type
        data.country = printInfo?.country?.name
        data.state = printInfo?.state?.name

        dispatch(getPrinterFromProduct(data))
    }, [printInfo, dispatch])

    const fucntionToFetchCountries = async () => {
        let country = await FetchCountryListdata()
        setCountries(country)
    }
    const fucntionToFetchStates = async (code) => {
        let statesdata = await FetchStateListdata(code)
        setStates(statesdata)
    }
    const fucntionToFetchCities = async (countryCode, stateCode) => {
        let citiesData = await FetchCityListdata(countryCode, stateCode)
        setCities(citiesData)
    }
    useEffect(() => {
        fucntionToFetchCountries()
    }, [])

    useEffect(() => {
        if (printInfo?.country?.code !== '') {
            fucntionToFetchStates(printInfo?.country?.code)
        }
        if (printInfo?.state?.code !== '' && printInfo?.country?.code !== '') {
            fucntionToFetchCities(printInfo?.country?.code, printInfo?.state?.code)
        }
    }, [printInfo])
    const handlePriceWithSpray = (x) => {
        if (printInfo?.print_option === "Canvas" && printInfo?.is_spray === true) {

            if (x && x.canvases.length > 0) {

                for (let i = 0; i < x.canvases.length; i++) {
                    let y = x.canvases[i];

                    // Check if the canvas name and size match the printInfo
                    if (y.name === printInfo.canvas_type && y.sizes.includes(printInfo.size)) {

                        // Split the size string and ensure it's valid (e.g., has 3 parts)
                        let size = printInfo?.size?.split(" ");

                        if (size.length < 3) {
                            console.error("Invalid size format.");
                            return null;
                        }

                        // Extract state price
                        let statePrice = x.serving_areas.flatMap(area =>
                            area.state
                                ?.filter(state => state.name === printInfo?.state?.name)
                                ?.map(state => state.price)
                        );

                        // Ensure statePrice has a valid value before proceeding
                        if (statePrice.length === 0) {
                            console.error("No state price found.");
                            return null;
                        }

                        // Calculate the price: canvas price + spray cost + state price
                        let price = Number(Number(size[0]) * Number(size[2] * y.price)) +
                            Number(Number(x.spray_cost_per_inch) * Number(size[0]) * Number(size[2])) +
                            Number(statePrice[0]);

                        // Return the computed printer charge and price including admin and artist percentages
                        return {
                            printer_charge: Number(price),
                            price: Number(Number(price) + (Number(price) * (adminPercentage / 100)) + (Number(price) * (artistPercentage / 100))).toFixed(6)
                        };
                    }
                }

                // Return null if no canvas matches
                return null;
            }

        }

    }


    const buynowBtn = async (e) => {
        e.preventDefault()

        if (!printInfo.printStyle) return toastr.error("Buying option is required")
        if (!printInfo.size) return toastr.error("Size is required")
        if (!printInfo.canvas_type) return toastr.error("Option is required")
        if (!printInfo.address) return toastr.error("Address is required")
        if (!printInfo.landmark) return toastr.error("Landmark is required")
        if (!printInfo.pincode) return toastr.error("Pincode is required")
        if (!printInfo.city) return toastr.error("City is required")
        if (!printInfo.state) return toastr.error("State is required")
        if (!printInfo.user_id) return toastr.error("User Id is required")
        if (printInfo.partner_id === "") return toastr.error("Please Select Printer")
        if (!printInfo.nft_id) return toastr.error("Digital Artwork Id is required")

        await web3Function()
    };
    async function web3Function() {
        let calamount_cal = 0;
        if (Number(ownerPriceMatic) > 0) {
            calamount_cal = Number(printInfo?.total_cost_matic) - Number(ownerPriceMatic);
        }
        const physicalData = {
            owner: sellItem?.creator_wallet,
            totalAmount: Number(Number(printInfo?.total_cost_matic).toFixed(4)),
            physicalOwnerAmount: Number(Number(ownerPriceMatic).toFixed(6)),
            calamount: Number(calamount_cal.toFixed(6))

        };
        const web3Interaction = new Web3Intraction("polygon", hooks?.walletType, settings);
        // sahil 
        setBidProgress(true);

        try {
            console.log("walletAddress2412312", wallAddress, physicalData)
            const res = await web3Interaction.buyPhysicalNFT(wallAddress, physicalData);
            if (res.status) {
                const printRequestData = {
                    ...printInfo,
                    admin_earning: calPercentAmt(adminPercent, printInfo?.printer_alone_charge),
                    printer_earning: printInfo?.printer_alone_charge,
                    seller_earning: calPercentAmt(artistPercent, printInfo?.printer_alone_charge),
                    order_received_date: formatDate(new Date()),
                    due_date: formatDateAddDays(new Date()),
                    owner_id: sellItem?.owner_id
                };

                dispatch(addPrintRequest(printRequestData, addPrintCallback));

            } else {
                setBidProgress(false);
                toastr.error("Something went wrong during the physical Digital Artwork purchase.");

            }
        } catch (err) {
            toastr.error(err.message || "An error occurred.");

        }
    }
    const conversionFunc = async (amountPrice, from, to) => {
        let data = await coversion(amountPrice, from, to);
        return data
    };



    useEffect(() => {
        const calculateTotalPrice = async () => {
            if (printInfo?.partner_id) {
                let premiumCost = 0;
                let tax = 0;
                let print_charge = 0;
                let nftPrice = 0;

                // Assign values based on conditions
                if (sellItem?.premium_print_cost > 0) premiumCost = Number(sellItem?.premium_print_cost);
                if (printInfo?.tax > 0) tax = Number(printInfo?.tax);
                if (printInfo?.print_charge) print_charge = 0
                if (printInfo?.printStyle === "Digital" || printInfo?.printStyle === "Digital+Physical") nftPrice = Number(sellItem?.price);

                try {
                    // Wait for the conversion to complete
                    let convertedCharge = await conversionFunc(Number(printInfo?.print_charge), "USD", "MATIC")
                    convertedCharge = Number(convertedCharge)



                    const totalPriceMatic = (printInfo?.printStyle === "Physical" ? 0 : nftPrice) + tax + convertedCharge + premiumCost;
                    const totalPriceDollar = await conversionFunc(totalPriceMatic, "MATIC", "USD")

                    // owner price 
                    setOwnerPriceMatic(convertedCharge * (adminPercentage / (100)) + premiumCost)
                    setPrinterChargeMatic(convertedCharge)
                    // Update the state with the calculated totalPrice and premiumCost
                    setPrintInfo((p) => ({ ...p, total_cost: totalPriceDollar, total_cost_matic: totalPriceMatic, premium_charge: premiumCost }));
                } catch (error) {
                    console.error("Error calculating total price:", error);
                }
            }
        };

        // Trigger the async calculation
        calculateTotalPrice();
    }, [
        printInfo?.printStyle,
        sellItem?.price,
        printInfo?.tax,
        sellItem?.premium_print_cost,
        printInfo?.print_charge,
        printInfo?.is_spray,
        printInfo?.print_option,
    ]);

    return (
        <>
            {bidProgress == true ?
                <div className="processingDialog">
                    <h1>
                        <i className="fa-duotone fa-loader"></i>
                    </h1>
                    <h1>Processing</h1>
                    <p> Metamask processing....</p>
                </div> : <>
                    {(addPrintloding) &&
                        <div className='loaderBoxMiane'>
                            <Oval
                                height={80}
                                width={80}
                                color="#6C63FF"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={true}
                                ariaLabel='oval-loading'
                                secondaryColor="#6C63FF"
                                strokeWidth={2}
                                strokeWidthSecondary={2}

                            />
                        </div>
                    }

                    <div class="dialogHeader">
                        <h3> Print Request</h3>
                        <button onClick={CloseDialog}>
                            <i class="fa-regular fa-xmark">
                            </i>
                        </button>
                    </div>
                    <div className="printbox">
                        <h3>Choose Your <span className="spantext">Print Style</span></h3>
                        <div className="d-flex gap-3 pt-3 pb-4">
                            <button className="printcommon-btn active"> Physical</button>
                        </div>

                        {/*
                <h3>Select Your<span className="spantext"> Canvas Option</span> </h3>
                <div className="d-flex gap-3 pt-3 pb-4">
                    <button className={`printcommon-btn ${printInfo?.canvas_type === "Canvas Lyve Matte" ? "active" : ''}`} onClick={() => handleOnChangePrintInfo("canvas_type", "Canvas Lyve Matte")}> Canvas Lyve Matte</button>
                    <button className={`printcommon-btn ${printInfo?.canvas_type === "Premium Matte" ? "active" : ''}`} onClick={() => handleOnChangePrintInfo("canvas_type", "Premium Matte")}> Premium Matte </button>
                    <button className={`printcommon-btn ${printInfo?.canvas_type === "Archival" ? "active" : ''}`} onClick={() => handleOnChangePrintInfo("canvas_type", "Archival")}> Archival</button>
                </div> */}
                    </div>
                    <>
                        <div className="printbox">
                            {/* <div className="printadd-form"><h3>Enter Your <span className="spantext">Delivering Address</span> </h3>
                        <form>

                            <input className="form-style" placeholder="3 Abu Ajeeba Street, Damanhur" id="Address" type="text" name="name" onChange={(e) => handleOnChangePrintInfo("address_line_1", e.target.value)} value={printInfo?.address_line_1} />
                            <div className="d-flex gap-2 m-auto w-100">
                                <div className="form-group d-flex gap-2 m-auto w-100">

                                    <select
                                        className="form-select form-control mb-2"
                                        name="country"
                                        value={printInfo?.country?.code}
                                        onChange={(e) => handleOnChangePrintInfo("country", e.target.value)}
                                        required
                                    >
                                        <option value="" disabled>Select Country</option>
                                        {countries?.map((country) => (
                                            <option key={country.code} name={country.code} value={country.code} >
                                                {country.name}
                                            </option>
                                        ))}
                                    </select>

                                    <select
                                        className="form-select form-control mb-2"
                                        name="state"
                                        value={printInfo?.state?.code}
                                        onChange={(e) => handleOnChangePrintInfo("state", e.target.value)}
                                        disabled={!printInfo?.country}
                                        required
                                    >
                                        <option value="" disabled>Select State</option>
                                        {states?.map((state) => (
                                            <option key={state.code} name={state.code} value={state.code} >
                                                {state.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <input className="form-style" onChange={(e) => handleOnChangePrintInfo("landmark", e.target.value)} value={printInfo?.landmark} type="text" id="LandMark" placeholder="LandMark" name="LandMark" />
                                <input className="form-style" onChange={(e) => handleOnChangePrintInfo("pincode", e.target.value)} value={printInfo?.pincode} type="text" id="Pincode" placeholder="Pincode" name="Pincode" />
                                <input className="form-style" onChange={(e) => handleOnChangePrintInfo("city", e.target.value)} value={printInfo?.city} type="text" id="City" placeholder="City" name="City" />
                                <input className="form-style" onChange={(e) => handleOnChangePrintInfo("state", e.target.value)} value={printInfo?.state} type="text" id="State" placeholder="State" name="State" />

                            </div>
                            <div className="selectPrinter">
                                <h3>Select <span className="txtclr"> Printer</span></h3>
                                <div class="table-responsive">
                                    <table class="summary-table">
                                        {Printers.map((item, ind) => (
                                            <tr className="price" >
                                                <th>{item?.fullName}</th>
                                                <td><label for="Radios1" >{handlePrice(item)}</label>
                                                    <input class="form-check-input" type="radio" name="Radios" id="Radiosbtn1" value={item._id} onClick={(e) => handlePrinterSelect(item)}
                                                        checked={selectedPrinterId === item._id ? true : false}
                                                    />
                                                </td>
                                            </tr>
                                        ))}{Printers.length === 0 && <h5 className="text-align-center">No Printer Found</h5>}
                                    </table>
                                </div>
                            </div>

                        </form>
                    </div> */}
                            <div className="sizeBox"><h3>Enter Your <span className="txtclr">Delivering Address</span> </h3>
                                <form>
                                    <div className="form-group d-flex gap-2 m-auto w-100">

                                        <select
                                            className="form-select form-control mb-2"
                                            name="country"
                                            value={printInfo?.country?.code}
                                            onChange={(e) => handleOnChangePrintInfo(e, "country", e.target.value)}
                                            required
                                        >
                                            <option value="" disabled>Select Country</option>
                                            {countries?.map((country) => (
                                                <option key={country.code} name={country.code} value={country.code} >
                                                    {country.name}
                                                </option>
                                            ))}
                                        </select>

                                        <select
                                            className="form-select form-control mb-2"
                                            name="state"
                                            value={printInfo?.state?.code}
                                            onChange={(e) => handleOnChangePrintInfo(e, "state", e.target.value)}
                                            disabled={!printInfo?.country}
                                            required
                                        >
                                            <option value="" disabled>Select State</option>
                                            {states?.map((state) => (
                                                <option key={state.code} name={state.code} value={state.code} >
                                                    {state.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <input className="form-control mb-2" onChange={(e) => handleOnChangePrintInfo(e, "address", e.target.value)} value={printInfo?.address} placeholder="3 Abu Ajeeba Street, Damanhur" id="Address" type="text" name="name" />
                                    </div>
                                    <div className="form-group d-flex gap-2 m-auto w-100">
                                        <input className="form-control mb-2" onChange={(e) => handleOnChangePrintInfo(e, "landmark", e.target.value)} value={printInfo?.landmark} type="text" id="LandMark" placeholder="LandMark" name="LandMark" />
                                        <input className="form-control mb-2" onChange={(e) => handleOnChangePrintInfo(e, "pincode", e.target.value)} value={printInfo?.pincode} type="text" id="Pincode" placeholder="Pincode" name="Pincode" />


                                        <select
                                            className="form-select form-control mb-2"
                                            name="country"
                                            value={printInfo?.city}
                                            onChange={(e) => handleOnChangePrintInfo(e, "city", e.target.value)}
                                            required
                                        >
                                            <option value="" disabled>Select City</option>
                                            {citites?.map((city) => (
                                                <option key={city?.name} name={city?.name} value={city?.name} >
                                                    {city?.name}
                                                </option>
                                            ))}
                                        </select>

                                    </div>

                                    <div className="printStyle">
                                        <h3>Select <span className="txtclr">Print Option</span></h3>
                                        <div className="d-flex gap-3 pt-3">
                                            <button className={`printcommon-btn ${printInfo?.print_option === 'Paper' ? 'active' : ''}`} onClick={(e) => printOption(e, 'Paper', "A1")}> Paper</button>
                                            <button className={`printcommon-btn ${printInfo?.print_option === 'Canvas' ? 'active' : ''}`} onClick={(e) => printOption(e, 'Canvas', "24 x 24")}> Canvas</button>

                                        </div>
                                    </div>
                                    {(printInfo?.print_option === "Paper") &&
                                        <div className="sizeBox">
                                            <h3>Select Your <span className="txtclr">Size Option</span></h3>
                                            <div className="d-flex gap-3 pt-3">

                                                {paperSizes?.map((item, i) =>
                                                    <button key={i} className={`printcommon-btn Aforsizebtn  ${printInfo?.canvas_type === item ? "active" : ""}`} onClick={() => setPrintInfo((p) => ({ ...p, canvas_type: item, partner_id: '', total_cost: 0 }))} > {item}</button>
                                                )}

                                            </div>
                                        </div>}
                                    {(printInfo?.print_option === "Canvas") &&
                                        <>
                                           
                                            <div>
                                                <div>
                                                    <div className="printStyle"><h3>Select Your<span className="txtclr"> Canvas Option</span> </h3>
                                                        <div className="d-flex gap-3 pt-3">
                                                            <button className={`printcommon-btn ${printInfo?.canvas_type === "Canvas Lyve Matte" ? "active" : ''}`} onClick={(e) => handleOnChangePrintInfo(e, "canvas_type", "Canvas Lyve Matte")}> Canvas Lyve Matte</button>
                                                            <button className={`printcommon-btn ${printInfo?.canvas_type === "Premium Matte" ? "active" : ''}`} onClick={(e) => handleOnChangePrintInfo(e, "canvas_type", "Premium Matte")}> Premium Matte </button>
                                                            <button className={`printcommon-btn ${printInfo?.canvas_type === "Archival" ? "active" : ''}`} onClick={(e) => handleOnChangePrintInfo(e, "canvas_type", "Archival")}> Archival</button>
                                                        </div>
                                                    </div>



                                                </div>
                                            </div>
                                            <h3>Select Your <span className="spantext">Size Option</span></h3>
                                            <div className="d-flex gap-3 pt-3 pb-4">
                                                {sizeOptions.map((option, ind) => (
                                                    <button onClick={(e) => handleOnChangePrintInfo(e, "size", option.label)}
                                                        key={option.label}
                                                        className={`printcommon-btn ${printInfo?.size === option?.label ? "active" : ''}`}
                                                    >
                                                        {option.label}
                                                    </button>
                                                ))}
                                            </div>
                                            </>
                                            }
                                    {printInfo?.print_option !== "Paper" &&
                                        <div className="printStyle">
                                            <h3>Spray</h3>
                                            <div className="d-flex gap-3 pt-3">
                                                <button className={`printcommon-btn Aforsizebtn ${printInfo?.is_spray === true ? 'active' : ''}`} onClick={(e) => {
                                                    e.preventDefault()

                                                    setPrintInfo((p) => (

                                                        { ...p, is_spray: true, total_cost: 0, partner_id: '' }))
                                                    return
                                                }}> Yes</button>
                                                <button className={`printcommon-btn Aforsizebtn ${printInfo?.is_spray === false ? 'active' : ''}`} onClick={(e) => {
                                                    e.preventDefault()
                                                    setPrintInfo((p) => ({ ...p, is_spray: false, total_cost: 0, partner_id: '' }))
                                                    return
                                                }}> No</button>
                                            </div>
                                        </div>}
                                    <div className="printStyle">
                                        <h3>Select <span className="txtclr"> Printer</span></h3>
                                        <div class="table-responsive">
                                            <table class="summary-table">


                                                {Printers?.map((item, ind) => (
                                                    <tr className="price" >
                                                        <th>{item?.shop_name}</th>
                                                        <td><label for="Radios1" >{(printInfo?.is_spray === false)
                                                            ? `$${handlePrice(item)?.price ? handlePrice(item)?.price : 0}`
                                                            : `$${handlePriceWithSpray(item)?.price}`} </label>
                                                            <input class="form-check-input" type="radio" name="Radios" id="Radiosbtn1" value={item._id} onClick={(e) => handlePrinterSelect(e, item)}
                                                                checked={printInfo?.partner_id === item._id ? true : false}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}

                                                {Printers.length === 0 && <h5 className="text-align-center">No Printer Found</h5>}
                                            </table>
                                        </div>
                                        {/* </div> */}
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="printbox">
                            <h3 className="txt-font">Price</h3>
                            <h4>{nftDet?.nft_id?.name} </h4>
                            <div class="table-responsive">
                                <table class="printbox-table">
                                    <tr className="txt-font">
                                        <th >Physical {printInfo?.print_option==="Paper"? printInfo?.canvas_type : printInfo?.size}</th>  
                                        <td></td>
                                    </tr>
                                    <tr className="printprice">
                                        <th>Amount</th>
                                        <td>{Number(printInfo?.print_charge) + Number(printInfo?.tax)} POL</td>
                                    </tr>
                                    <tr className="printprice">
                                        <th>Printing Charge</th>
                                        <td>{printInfo?.print_charge} POL</td>
                                    </tr>
                                    <tr className="printprice">
                                        <th>Tax</th>
                                        <td>{printInfo?.tax} POL</td>
                                    </tr>
                                    <tr>
                                        <td className="p-2"></td>
                                    </tr>
                                    <tr className="totalprintprice">
                                        <th>Total</th>
                                        <td>{Number(printInfo?.print_charge) + Number(printInfo?.tax)} POL</td>
                                    </tr>
                                </table>
                            </div>
                            <div className="prt-btn">
                                <button className="btn btn-secondary text-white fw-semibold m-auto" onClick={(e) => buynowBtn(e)}>Submit Request</button>
                            </div>
                        </div>
                    </>
                </>}
        </>

    );
}
function calPercentAmt(percentage = 25, amount = 100) {
    return ((percentage / 100) * amount).toFixed(6)
}